import { apiConstants } from 'api/constants'
import { ICourseCard } from 'models/courseCard.model'
import { IEnrolCard } from 'models/enrolCard.model'
import api from '..'

export type MyCoursesListByStatus = Record<
  'pending' | 'inProgress' | 'finish' | 'imparted' | 'soon',
  {
    courses: {
      course: ICourseCard
      enrol: IEnrolCard
    }[]
    total: number
  }
>

const myCoursesList = ({ search = '' }) => {
  return api
    .get<MyCoursesListByStatus>('courses/by_statuses', {
      params: {
        per_state: apiConstants.perState,
        search: search,
      },
    })
    .then(({ data }) => data)
}

export default myCoursesList
